import { buildJustLyricsContext } from '../contexts/justlyrics-context';

/**
 * Loop Manager for Music/Lyrics queries.
 * Evaluates if the initial lyric fetch was sufficient, or if the user is asking
 * for deep lyrical analysis that requires iterating (looping).
 */
export async function executeJustLyricsLoop(seedPrompt: string, initialResponse?: string): Promise<string> {
    console.log(`[JustLyrics Loop Engine] Evaluating lyric request for: "${seedPrompt}"`);
    
    // Step 1: Base Context Fetch (Version 1)
    let context = await buildJustLyricsContext(seedPrompt);
    
    // Step 2: Quality Control / Loop Evaluation
    const userWantsDeepDive = seedPrompt.toLowerCase().includes("deep dive") || seedPrompt.toLowerCase().includes("hidden meaning") || seedPrompt.toLowerCase().includes("break down");
    
    if (userWantsDeepDive && context.includes("Here are the exact lyrics")) {
        // The user wants a very detailed breakdown. We inject loop parameters to force 
        // the LLM to structure a track review rather than just spitting out text.
        context += `\n[LOOP-ENGINEERING INJECTION: The user has requested a deep dive. Break the lyrics down verse-by-verse. Provide historical context about the artist's mindset if possible, and analyze the rhyme scheme and metaphors in detail.]\n`;
    }

    return context;
}
